import { IPlayerChannel } from "../../../interfaces/player/IPlayerUIState.ts";
import PlayerChannel from "../PlayerChannel.tsx";
import { useAppSelector } from "../../../stores/store.ts";
import PlayerChannelListMobile from "./PlayerChannelListMobile.tsx";

interface IProps {
    channels: IPlayerChannel[]
}

const PlayerUiBottomBarMobile = ({ channels }: IProps) => {
    const actualChannelIndex = useAppSelector(store => store.playerUI.actualChannelIndex);
    const heightVideoPlayer = (window.innerWidth / 16 * 9);
    return (
        <div className={"flex sm:hidden flex-col justify-center"} style={{ height: `calc(100% - ${heightVideoPlayer}px` }}>
            {actualChannelIndex >= 0 &&
                <>
                    <div className={"h-px pt-px bg-linear-to-r from-transparent via-[#008DD2] to-transparent w-full"} />
                    <PlayerChannel channel={channels[actualChannelIndex]} className={"mt-4"} />
                    <div className={"mt-6 h-px pb-px bg-linear-to-r from-transparent via-[#008DD2] to-transparent w-full"} />
                </>
            }
            <PlayerChannelListMobile channels={channels} />
        </div>
    )
};

export default PlayerUiBottomBarMobile;